export const SLASH_COMMANDS = {
  BLOG_IDEAS: {
    labelKey: 'inlineAutocompleteMenu.ideas.label',
    commandId: 'blog_inline_slash_commands_give_me_ideas_v1',
    // TODO: Probably i18n this
    id: 'generateideas',
    headerKey: 'inlineAutocompleteMenu.ideas.menuHeader',
    placeholder: 'inlineAutocompleteMenu.ideas.placeholder',
    parameters: {
      voiceChannel: 'BLOG',
      promptThread: 'copilotCollaboration.command.ideas.promptThread'
    }
  },
  BLOG_PARAGRAPH: {
    labelKey: 'inlineAutocompleteMenu.paragraph.label',
    commandId: 'blog_inline_slash_commands_generate_paragraph_v2',
    id: 'generateparagraph',
    headerKey: 'inlineAutocompleteMenu.paragraph.menuHeader',
    placeholder: 'inlineAutocompleteMenu.paragraph.placeholder',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    parameters: {
      promptForMoreInfo: true,
      voiceChannel: 'BLOG',
      promptThread: 'copilotCollaboration.command.paragraph.promptThread',
      promptPrefix: 'Write a paragraph for this blog post based on the following instructions: '
    }
  },
  BLOG_OUTLINE: {
    labelKey: 'inlineAutocompleteMenu.outline.label',
    commandId: 'blog_inline_slash_commands_generate_an_outline_v1',
    id: 'generateoutline',
    headerKey: 'inlineAutocompleteMenu.outline.menuHeader',
    placeholder: 'inlineAutocompleteMenu.outline.placeholder',
    parameters: {
      promptForMoreInfo: true,
      voiceChannel: 'BLOG',
      promptThread: 'copilotCollaboration.command.outline.promptThread',
      promptPrefix: 'Write an outline for this blog post based on the following instructions: '
    }
  },
  BLOG_CONCLUSION: {
    labelKey: 'inlineAutocompleteMenu.conclusion.label',
    commandId: 'blog_inline_slash_commands_generate_conclusion_v2',
    id: 'generateconclusion',
    headerKey: 'inlineAutocompleteMenu.conclusion.menuHeader',
    placeholder: 'inlineAutocompleteMenu.conclusion.placeholder',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    parameters: {
      promptForMoreInfo: true,
      voiceChannel: 'BLOG',
      promptThread: 'copilotCollaboration.command.conclusion.promptThread',
      promptPrefix: 'Write a conclusion for this blog post based on the following instructions: '
    }
  },
  CTA_HEADING: {
    labelKey: 'inlineAutocompleteMenu.heading.label',
    commandId: 'cta_inline_slash_commands_generate_heading_v1',
    id: 'generatingheading',
    headerKey: 'inlineAutocompleteMenu.heading.menuHeader',
    placeholder: 'inlineAutocompleteMenu.heading.placeholder',
    parameters: {
      promptForMoreInfo: true,
      promptThread: 'copilotCollaboration.command.heading.promptThread',
      promptPrefix: 'Write a heading for this website pop-up based on the following instructions: '
    }
  },
  CTA_PARAGRAPH: {
    labelKey: 'inlineAutocompleteMenu.paragraph.label',
    commandId: 'cta_inline_slash_commands_generate_paragraph_v1',
    id: 'generateparagraph',
    headerKey: 'inlineAutocompleteMenu.paragraph.menuHeader',
    placeholder: 'inlineAutocompleteMenu.paragraph.placeholder',
    parameters: {
      promptForMoreInfo: true,
      promptThread: 'copilotCollaboration.command.paragraph.promptThread',
      promptPrefix: 'Write a concise paragraph for this website pop-up based on the following instructions: '
    }
  },
  CTA_SUBSECTION: {
    labelKey: 'inlineAutocompleteMenu.subsection.label',
    commandId: 'cta_inline_slash_commands_generate_subsection_v1',
    id: 'generatesubsection',
    headerKey: 'inlineAutocompleteMenu.subsection.menuHeader',
    placeholder: 'inlineAutocompleteMenu.subsection.placeholder',
    parameters: {
      promptForMoreInfo: true,
      promptThread: 'copilotCollaboration.command.subsection.promptThread',
      promptPrefix: 'Write a subsection for this website pop-up based on the following instructions: '
    }
  },
  PAGES_HEADING: {
    labelKey: 'inlineAutocompleteMenu.heading.label',
    commandId: 'page_inline_slash_commands_generate_heading_v1',
    // TODO: Probably i18n this
    id: 'generatingheading',
    headerKey: 'inlineAutocompleteMenu.heading.menuHeader',
    placeholder: 'inlineAutocompleteMenu.heading.placeholder'
  },
  PAGES_PARAGRAPH: {
    labelKey: 'inlineAutocompleteMenu.paragraph.label',
    commandId: 'page_inline_slash_commands_generate_paragraph_v1',
    id: 'generateparagraph',
    headerKey: 'inlineAutocompleteMenu.paragraph.menuHeader',
    placeholder: 'inlineAutocompleteMenu.paragraph.pagePlaceholder'
  },
  PAGES_SUBSECTION: {
    labelKey: 'inlineAutocompleteMenu.subsection.label',
    commandId: 'page_inline_slash_commands_generate_subsection_v1',
    id: 'generatesubsection',
    headerKey: 'inlineAutocompleteMenu.subsection.menuHeader',
    placeholder: 'inlineAutocompleteMenu.subsection.placeholder'
  },
  // These are just for the pages app because they use brand voice and BV is not
  // yet supported in the other apps using PAGES_REPHRASE, PAGES_EXPAND_IDEA,
  // and PAGES_SUMMARIZE_IDEA (i.e. GCE, web interactives)
  PAGES_HEADING_V2: {
    labelKey: 'inlineAutocompleteMenu.heading.label',
    commandId: 'page_inline_slash_commands_generate_heading_v2',
    parameters: {
      voiceChannel: 'PAGES',
      promptForMoreInfo: true,
      promptThread: 'copilotCollaboration.command.heading.promptThread',
      promptPrefix: 'You are an expert content marketer with experience creating high performing and conversion optimized web pages. You are tasked with creating the heading of the page. Generate a heading that is engaging, clear, and specific to the page. The heading copy should be no more than 76 characters.'
    },
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    // TODO: Probably i18n this
    id: 'generatingheading',
    headerKey: 'inlineAutocompleteMenu.heading.menuHeader',
    placeholder: 'inlineAutocompleteMenu.heading.placeholder'
  },
  PAGES_PARAGRAPH_V2: {
    labelKey: 'inlineAutocompleteMenu.paragraph.label',
    commandId: 'page_inline_slash_commands_generate_paragraph_v2',
    parameters: {
      promptForMoreInfo: true,
      voiceChannel: 'PAGES',
      promptThread: 'copilotCollaboration.command.paragraph.promptThread',
      promptPrefix: 'You are an expert content marketer with experience creating high performing and conversion optimized web pages. You are tasked with writing a compelling and relevant paragraph for the page. Generate a paragraph that is engaging, clear, and specific. Keep the value proposition of the page in mind and focus on the user goal.'
    },
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    id: 'generateparagraph',
    headerKey: 'inlineAutocompleteMenu.paragraph.menuHeader',
    placeholder: 'inlineAutocompleteMenu.paragraph.pagePlaceholder'
  },
  PAGES_SUBSECTION_V2: {
    labelKey: 'inlineAutocompleteMenu.subsection.label',
    commandId: 'page_inline_slash_commands_generate_subsection_v2',
    parameters: {
      promptForMoreInfo: true,
      voiceChannel: 'PAGES',
      promptThread: 'copilotCollaboration.command.subsection.promptThread',
      promptPrefix: 'You are an expert content marketer with experience creating high performing and conversion optimized web pages. Generate a subsection for this page that is engaging, clear, and specific. Keep the value proposition of the page in mind and focus on the user goal. The subsection should be concise without losing the general message.'
    },
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    id: 'generatesubsection',
    headerKey: 'inlineAutocompleteMenu.subsection.menuHeader',
    placeholder: 'inlineAutocompleteMenu.subsection.placeholder'
  },
  IMAGE: {
    // image generation doesn't use the CA components or command execution (instead delegating to the file picker),
    // so we only need labels for the CA dropdown / slash command popover
    id: 'generateimage',
    labelKey: 'inlineAutocompleteMenu.image.label'
  },
  EMAIL_PARAGRAPH_V2: {
    labelKey: 'inlineAutocompleteMenu.emailParagraph.label',
    commandId: 'marketing_email_inline_slash_commands_generate_paragraph_v2',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    id: 'generateparagraph',
    headerKey: 'inlineAutocompleteMenu.emailParagraph.menuHeader',
    placeholder: 'inlineAutocompleteMenu.emailParagraph.placeholder',
    parameters: {
      voiceChannel: 'EMAIL',
      promptForMoreInfo: true,
      promptThread: 'copilotCollaboration.command.paragraph.promptThread',
      promptPrefix: 'You are an expert email marketing specialist. Use your expert writing skills to craft a unique and captivating email paragraph about: '
    }
  },
  EMAIL_PARAGRAPH_V3: {
    labelKey: 'inlineAutocompleteMenu.emailParagraph.label',
    commandId: 'marketing_email_inline_slash_commands_generate_paragraph_v3',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    id: 'generateparagraph',
    headerKey: 'inlineAutocompleteMenu.emailParagraph.menuHeader',
    placeholder: 'inlineAutocompleteMenu.emailParagraph.placeholder',
    parameters: {
      voiceChannel: 'EMAIL',
      promptForMoreInfo: true,
      promptThread: 'copilotCollaboration.command.paragraph.promptThread',
      promptPrefix: 'You are an expert email marketing specialist. Use your expert writing skills to craft a unique, captivating and concise email paragraph. Ensure the generated paragraph is 40-60 words max. The paragraph should serve a clear purpose and move the reader toward action. The topic is: '
    }
  },
  EMAIL_HEADING_V2: {
    labelKey: 'inlineAutocompleteMenu.emailHeading.label',
    commandId: 'marketing_email_inline_slash_commands_generate_heading_v2',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    id: 'generatingheading',
    headerKey: 'inlineAutocompleteMenu.emailHeading.menuHeader',
    placeholder: 'inlineAutocompleteMenu.emailHeading.placeholder',
    parameters: {
      voiceChannel: 'EMAIL',
      promptForMoreInfo: true,
      promptThread: 'copilotCollaboration.command.heading.promptThread',
      promptPrefix: "You're an expert email marketing specialist building a high performing marketing email. Write an engaging heading and an attention-grabbing subheading for a marketing email about: "
    }
  },
  EMAIL_HEADING_V3: {
    labelKey: 'inlineAutocompleteMenu.emailHeading.label',
    commandId: 'marketing_email_inline_slash_commands_generate_heading_v3',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    id: 'generatingheading',
    headerKey: 'inlineAutocompleteMenu.emailHeading.menuHeader',
    placeholder: 'inlineAutocompleteMenu.emailHeading.placeholder',
    parameters: {
      voiceChannel: 'EMAIL',
      promptForMoreInfo: true,
      promptThread: 'copilotCollaboration.command.heading.promptThread',
      promptPrefix: `You're an expert email marketing specialist building a high performing marketing email. Write an engaging heading. Keep it short and impactful, aim for 3-7 words (or less than 50 characters). Make it benefit-driven, showing the reader what's in it for them. Encourage engagement with verbs that drive action. If applicable, add a sense of scarcity or exclusivity. If applicable include one of the following personalisation tokens:
          - {{ contact.firstname }}: the first name of the email recipient.
          - {{ contact.company }}: the company name of the email recipient.
        The topic is: `
    }
  },
  SMS_MESSAGE: {
    labelKey: 'inlineAutocompleteMenu.smsMessage.label',
    commandId: 'sms_inline_slash_commands_generate_message_v1',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    id: 'generatingmessage',
    headerKey: 'inlineAutocompleteMenu.smsMessage.menuHeader',
    placeholder: 'inlineAutocompleteMenu.smsMessage.placeholder',
    parameters: {
      promptForMoreInfo: true,
      promptThread: 'copilotCollaboration.command.smsMessage.promptThread',
      voiceChannel: 'SMS',
      promptPrefix: `You are an expert marketing specialist. Use your expert writing skills to craft a unique and captivating SMS message. Personalisation tokens you can use:
          - {{ contact.firstname }}: the first name of the email recipient.
          - {{ contact.company }}: the company name of the email recipient
      A quality SMS should:
        1. Not include hashtags or emojis, you can use one or more personalisation tokens to personalise the message.
        2. Be under 140 characters
      Taking all of the above into consideration, write an SMS about:`
    }
  },
  HUBDB_IDEAS: {
    labelKey: 'inlineAutocompleteMenu.hubdbIdeas.label',
    commandId: 'hubdb_inline_slash_commands_give_me_ideas_v1',
    id: 'generateideas',
    headerKey: 'inlineAutocompleteMenu.hubdbIdeas.menuHeader',
    placeholder: 'inlineAutocompleteMenu.hubdbIdeas.placeholder'
  },
  HUBDB_PARAGRAPH: {
    labelKey: 'inlineAutocompleteMenu.hubdbParagraph.label',
    commandId: 'hubdb_inline_slash_commands_generate_paragraph_v1',
    id: 'generateparagraph',
    headerKey: 'inlineAutocompleteMenu.hubdbParagraph.menuHeader',
    placeholder: 'inlineAutocompleteMenu.hubdbParagraph.placeholder'
  },
  HUBDB_OUTLINE: {
    labelKey: 'inlineAutocompleteMenu.hubdbOutline.label',
    commandId: 'hubdb_inline_slash_commands_generate_an_outline_v1',
    id: 'generateoutline',
    headerKey: 'inlineAutocompleteMenu.hubdbOutline.menuHeader',
    placeholder: 'inlineAutocompleteMenu.hubdbOutline.placeholder'
  },
  CASE_STUDY_CONCLUSION: {
    labelKey: 'inlineAutocompleteMenu.conclusion.label',
    commandId: 'case_study_inline_slash_commands_generate_conclusion_v1',
    id: 'generateconclusion',
    headerKey: 'inlineAutocompleteMenu.conclusion.menuHeader',
    placeholder: 'inlineAutocompleteMenu.conclusion.placeholder',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    parameters: {
      voiceChannel: 'CASE_STUDY',
      promptForMoreInfo: true,
      promptThread: 'copilotCollaboration.command.conclusion.promptThread',
      promptPrefix: 'Write a conclusion for this case study based on the following instructions: '
    }
  },
  CASE_STUDY_PARAGRAPH: {
    labelKey: 'inlineAutocompleteMenu.paragraph.label',
    commandId: 'case_study_inline_slash_commands_generate_paragraph_v1',
    id: 'generateparagraph',
    headerKey: 'inlineAutocompleteMenu.paragraph.menuHeader',
    placeholder: 'inlineAutocompleteMenu.paragraph.placeholder',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.usingBrandVoice_jsx',
    parameters: {
      voiceChannel: 'CASE_STUDY',
      promptForMoreInfo: true,
      promptThread: 'copilotCollaboration.command.paragraph.promptThread',
      promptPrefix: 'Write a paragraph for this case study based on the following instructions: '
    }
  },
  // SocialUI
  SOCIAL_GENERIC_POST: {
    labelKey: 'inlineAutocompleteMenu.socialPost.label',
    headerKey: 'inlineAutocompleteMenu.socialPost.label',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.editBrandVoice_jsx',
    // Not an actual command: only used with copilot/chatspot/breeze
    commandId: 'social_post_mock_command_id',
    parameters: {
      promptForMoreInfo: true,
      promptPrefix: `You are an expert social media marketer who creates social media content that drives engagement and leads.
          A quality social post should:
            1. Be between 300-500 characters in length
            2. Concise and thoughtful
            3. Encourage the audience to engage with a question about the context of the post
            4. The tone should be casual and engaging.
          Taking all of the above in to consideration, write a social post about:`,
      promptThread: 'inlineAutocompleteMenu.socialPost.promptThread'
    }
  },
  SOCIAL_FACEBOOK_POST: {
    labelKey: 'inlineAutocompleteMenu.facebookPost.label',
    headerKey: 'inlineAutocompleteMenu.facebookPost.label',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.editBrandVoice_jsx',
    // Not an actual command: only used with copilot/chatspot/breeze
    commandId: 'social_post_mock_command_id',
    parameters: {
      promptForMoreInfo: true,
      promptPrefix: `You are an expert social media marketer who creates social media content that drives engagement and leads.
          A quality Facebook post should:
            1. Be between 300-500 characters in length
            2. Concise and thoughtful
            3. Encourage the audience to engage with a question about the context of the post
            4. The tone should be casual and engaging.
          Taking all of the above in to consideration, write a Facebook post about:`,
      promptThread: 'inlineAutocompleteMenu.facebookPost.promptThread'
    }
  },
  SOCIAL_INSTAGRAM_POST: {
    labelKey: 'inlineAutocompleteMenu.instagramPost.label',
    headerKey: 'inlineAutocompleteMenu.instagramPost.label',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.editBrandVoice_jsx',
    // Not an actual command: only used with copilot/chatspot/breeze
    commandId: 'social_post_mock_command_id',
    parameters: {
      promptForMoreInfo: true,
      promptPrefix: `You are an expert social media marketer who creates social media content that drives engagement and leads.
        A quality Instagram post should:
          1. Be between 100-150 characters in length
          2. Casual and lighthearted
          3. Should include 1-2 emojis relevant to the context of the post.
          4. Should include 1-3 relevant hashtags.
          5. The tone should be lighthearted and personable.
        Taking all of the above in to consideration, write an Instagram post about:`,
      promptThread: 'inlineAutocompleteMenu.instagramPost.promptThread'
    }
  },
  SOCIAL_X_POST: {
    labelKey: 'inlineAutocompleteMenu.xPost.label',
    headerKey: 'inlineAutocompleteMenu.xPost.label',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.editBrandVoice_jsx',
    // Not an actual command: only used with copilot/chatspot/breeze
    commandId: 'social_post_mock_command_id',
    parameters: {
      promptForMoreInfo: true,
      promptPrefix: `You are an expert social media marketer who creates social media content that drives engagement and leads.
        A quality X post should:
          1. Be between 100-280 characters in length
          2. Concise and light hearted
          3. Have the first sentence grab your attention.
          4. The tone coversational and positive
        Taking all of the above in to consideration, write an X post about:`,
      promptThread: 'inlineAutocompleteMenu.xPost.promptThread'
    }
  },
  SOCIAL_LINKEDIN_POST: {
    labelKey: 'inlineAutocompleteMenu.linkedinPost.label',
    headerKey: 'inlineAutocompleteMenu.linkedinPost.label',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.editBrandVoice_jsx',
    // Not an actual command: only used with copilot/chatspot/breeze
    commandId: 'social_linkedin_post',
    parameters: {
      promptForMoreInfo: true,
      promptPrefix: `You are an expert social media marketer who creates social media content that drives engagement and leads.
        A quality LinkedIn post should:
          1. Be between 150-300 characters or 900-1200 characters in length
          2. Have a strong and engaging opening headliner in the post
          3. Encourage the audience to share their thoughts or engage on the post
          4. Include 2-5 relevant hashtags
          5. The tone should be professional and warm
        Taking all of the above in to consideration, write a LinkedIn post about: `,
      promptThread: 'inlineAutocompleteMenu.linkedinPost.promptThread'
    }
  },
  SOCIAL_HASHTAGS: {
    labelKey: 'inlineAutocompleteMenu.socialHashtags.label',
    headerKey: 'inlineAutocompleteMenu.socialHashtags.label',
    brandVoiceLinkKey: 'baseContentGenerationModal.inlineToolbar.editBrandVoice_jsx',
    // Not an actual command: only used with copilot/chatspot/breeze
    commandId: 'social_hashtags',
    parameters: {
      promptForMoreInfo: true,
      promptPrefix: 'Create between 2 and 4 hashtags based on the following text: ',
      promptThread: 'inlineAutocompleteMenu.socialHashtags.promptThread'
    }
  },
  KB_HEADING: {
    labelKey: 'inlineAutocompleteMenu.heading.label',
    commandId: 'kb_inline_slash_commands_generate_heading',
    parameters: {
      promptForMoreInfo: true,
      promptThread: 'copilotCollaboration.command.heading.promptThread',
      promptPrefix: 'Write a heading for this knowledge base article based on the following instructions: '
    },
    id: 'generatingheading',
    headerKey: 'inlineAutocompleteMenu.heading.menuHeader',
    placeholder: 'inlineAutocompleteMenu.heading.placeholder'
  },
  KB_PARAGRAPH: {
    labelKey: 'inlineAutocompleteMenu.paragraph.label',
    commandId: 'kb_inline_slash_commands_generate_paragraph',
    parameters: {
      promptForMoreInfo: true,
      promptThread: 'copilotCollaboration.command.paragraph.promptThread',
      promptPrefix: 'Write a paragraph for this knowledge base article based on the following instructions: '
    },
    id: 'generateparagraph',
    headerKey: 'inlineAutocompleteMenu.paragraph.menuHeader',
    placeholder: 'inlineAutocompleteMenu.paragraph.pagePlaceholder'
  },
  KB_SUBSECTION: {
    labelKey: 'inlineAutocompleteMenu.subsection.label',
    commandId: 'kb_inline_slash_commands_generate_subsection',
    parameters: {
      promptForMoreInfo: true,
      promptThread: 'copilotCollaboration.command.subsection.promptThread',
      promptPrefix: 'Write a subsection for this knowledge base article based on the following instructions: '
    },
    id: 'generatesubsection',
    headerKey: 'inlineAutocompleteMenu.subsection.menuHeader',
    placeholder: 'inlineAutocompleteMenu.subsection.placeholder'
  }
};